import React from 'react';
import FloatingCta from '../../../components/floating-cta';

const EventFloatingCta = (props) => {
  const {
    cta: {
      callback: {
        icon: callbackIcon,
        text: callbackText,
      },
      callbackReceived: {
        icon: callbackReceivedIcon,
        text: callbackReceivedText,
      },
      expertFinder: {
        icon: expertFinderIcon,
        text: expertFinderText,
        url: expertFinderUrl,
      },
    },
    openModal,
    callbackRequestComplete,
  } = props;
  const ctas = [
    {
      icon: !callbackRequestComplete ? callbackIcon : callbackReceivedIcon,
      text: !callbackRequestComplete ? callbackText : callbackReceivedText,
      disableButton: callbackRequestComplete,
      onCtaClick: () => {
        if (!callbackRequestComplete) {
          openModal();
        }
      },
    },
    {
      icon: expertFinderIcon,
      text: expertFinderText,
      onCtaClick: () => {
        window.open(expertFinderUrl);
      },
    },
  ];

  return (
    <FloatingCta ctas={ctas} />
  );
};

export default EventFloatingCta;
